import { Button } from '@components';
import { useIsMobile } from '@hooks';
import { Stack, Typography, useTheme } from '@mui/material';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import Warning from '../Warning';

interface IProps {
  onBack: () => void;
}

const NotIncludedInResponsibleForZIPsStep: React.FC<IProps> = ({ onBack }) => {
  const theme = useTheme();
  const isMobile = useIsMobile();
  const navigate = useNavigate();

  const { formatMessage } = useIntl();

  return (
    <Warning>
      <Typography variant="overline" color="error.main" sx={{ marginBottom: theme.spacing(0.5) }}>
        <FormattedMessage id="eligibilityCheck.step.5.overline" />
      </Typography>
      <Typography variant="h2" sx={{ marginBottom: theme.spacing(2) }}>
        <FormattedMessage id="eligibilityCheck.step.5.notIncludedInResponsibleForZIPs.title" />
      </Typography>
      <Typography variant="body1" sx={{ marginBottom: theme.spacing(2) }}>
        <FormattedMessage id="eligibilityCheck.step.5.notIncludedInResponsibleForZIPs.description.2" />
      </Typography>
      <Typography
        variant="body1"
        sx={{ marginBottom: theme.spacing(4) }}
        dangerouslySetInnerHTML={{
          __html: formatMessage({ id: 'eligibilityCheck.step.5.notIncludedInResponsibleForZIPs.description.3' }),
        }}
      />
      <Stack direction="row" gap={isMobile ? 2 : 3}>
        <Button variant="outlined" onClick={onBack}>
          <FormattedMessage id="common.back" />
        </Button>
        <Button variant="contained" onClick={() => navigate('/login')} color="error">
          <FormattedMessage id="common.leave" />
        </Button>
      </Stack>
    </Warning>
  );
};

export default NotIncludedInResponsibleForZIPsStep;
